module.exports = __webpack_public_path__ + "img/microsoft-20x20.e50bcea5.svg";